import { z } from "zod";

/** Build-time configuration (Vite inlines VITE_*); validated once so a typo fails loudly. */
const Schema = z.object({
  VITE_API_URL: z.string().url().default("http://localhost:4410"),
  VITE_SENTRY_DSN: z.string().optional(),
  VITE_SENTRY_ENVIRONMENT: z.string().default("local"),
  /** Railway's commit SHA, passed as a build arg so an event names the deployed version. */
  VITE_SENTRY_RELEASE: z.string().optional(),
  /**
   * Development only: paste a real `initData` string here to open the app in a desktop
   * browser. Outside Telegram there is no signed payload, so the API would refuse.
   */
  VITE_DEV_INIT_DATA: z.string().optional(),
});

export const env = Schema.parse(import.meta.env);
